export default function RedQuickTag(props: { style?: any, children: any, title }) {
    return (<div style={{ position: 'relative', ...(props.style || {}) }}>
        <div style={{
            backgroundColor: '#ffffff',
            position: 'absolute',
            right: 0,
            top: 0,
        }}>{props.title}</div>
        {props.children}
    </div >)
}